import Vue from "vue";
import Vuex from "vuex";
import Log from "@/components/log";
import { env } from "@/env";
Vue.use(Vuex);

const KEY_PEFIX = env.VUE_APP_KEY + ":";
const authInfoStr = localStorage.getItem(KEY_PEFIX + "auth");
let initAuthInfo = null;
try {
  initAuthInfo = authInfoStr ? JSON.parse(authInfoStr) : null;
} catch (e) {
  Log.error(e);
}

const moduleCore = {
  state: {
    auth: initAuthInfo,
    wxUrl: null,
  },
  mutations: {
    putAuth(state: any, authInfo: any) {
      if (!authInfo) {
        return;
      }
      state.auth = authInfo;
      localStorage.setItem(KEY_PEFIX + "auth", JSON.stringify(authInfo));
    },
    clearAuth(state: any, authInfo: any) {
      delete state.auth;
      localStorage.removeItem(KEY_PEFIX + "auth");
    },
    // add for jssdk
    setWxUrl(state: any, wxUrlObj: { wxUrl: string; ios: boolean }) {
      // ios只记录第一次的url
      if (wxUrlObj.ios && state.wxUrl) {
        return;
      }
      state.wxUrl = wxUrlObj.wxUrl;
    },
  },
  actions: {},
};

export default new Vuex.Store({
  modules: {
    core: moduleCore,
  },
});
